import React, { useState } from "react";
import { FaAngleRight } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";

const Modal = ({ title, description }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <div className=" relative w-[270px] h-[270px] border-[0.5px] border-[#b3b3b3b3] border-solid rounded-sm shadow-xl pt-[6rem] pr-[0px] pl-[2.5rem] pb-[2rem]">
        <div className="mb-[3rem]">
          <h3 className="text-[1.25rem] font-medium">{title}</h3>
        </div>
        <span
          className="items-center gap-1 cursor-pointer inline-flex"
          onClick={() => setShowModal(true)}
        >
          Ver mais
          <FaAngleRight className="text-[#281566]" size={16} />
        </span>
      </div>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[100] outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-[1.5rem] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-solid border-slate-200 rounded-t">
                  <h3 className="text-2xl font-semibold">{title}</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <IoCloseSharp
                      className="text-[#281566] font-bold"
                      size={25}
                    />
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto items-center gap-1">
                  <p className="my-4 text-slate-500 text-lg leading-relaxed">
                    {description}
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Modal;
